/**
 * @description Module document
 */

/* global ModuloTS */

(() => {
	// VARS
	const root = document.querySelector('.content-404');

	// EVENTS
	const createButtonArea = (input, areaName, icon) => {
		if (root.querySelector(`${input}`)) {
			root.querySelector(`.${areaName}`).insertAdjacentHTML(
				'afterbegin',
				root.querySelector(`${input}`).outerHTML
			);
			root.querySelector(`.${areaName}`).insertAdjacentHTML(
				'beforeend',
				`<i data-icon=${icon}></i>`
			);
			root.querySelector(`${input}`).remove();
			root.querySelector(`${input}`).placeholder =
				ModuloTS['I search'] + '...';
		}
	};

	const page = () => {
		document
			.querySelector('.content-404 .button')
			.classList.remove('form-control', 'form-control-lg');
		document
			.querySelector('.content-404 .button')
			.classList.add('btn', 'btn-primary');
		document.querySelector('#block-spe-breadcrumbs').remove();
		document.querySelector('#block-spe-banner').remove();
	};
	// GO 🚀
	const init = () => {
		if (root) {
			page();
			createButtonArea(
				'.form-autocomplete',
				'content-404__search-input',
				'search'
			);
		}
	};

	init();
})();
